import { StatsigMicrolib } from './statsig.microlib';

(async function () {
  (window as any).statsigMicrolib = new StatsigMicrolib('client-g95ZbjNYI1HOI2dz0ws5JRrKfdGaTxXY8H6Eu7aSdsC');
})();
